import { ReduceStore } from 'flux/utils';
import Dispatcher from './../Dispatcher';
import ActionTypes from './ActionTypes';
import UserReportManager from './UserReportManager';

class ReportStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.USER_REPORT_STORE_FETCH:
        UserReportManager.fetch(action.parentType, action.parentId, action.store, action.username);
        return state;

      case ActionTypes.USER_REPORT_STORE_FETCH_COMPLETE:
        return action.data;

      default:
        return state;
    }
  }
}

export default new ReportStore();
